import { openNewTab } from '../../helpers';

let swiperImages;
let swiperContent;

export default function mainSlideshow() {
  const widgetName = 'mainSlideshow';
  const widgetOpts = mainSlideshowOpts;
  const $widget = $(`#${widgetName}`);

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $widget.html(swiperContainers);
      initSwiper($widget, widgetName, response.Slides);
      updateSwiper(swiperImages, swiperContent);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}

// --------------------------------------------
// Swiper Initialization
function initSwiper($widget, widgetName, widgetData) {
  if (widgetData.length <= 1) {
    $widget.addClass('single-slide');
  }
  const swiperWidgetImagesWrapper = $widget.find(`.swiper-container-images .swiper-wrapper`);
  const swiperWidgetContentWrapper = $widget.find(`.swiper-container-content .swiper-wrapper`);

  widgetData.forEach(function (slide) {
    swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
    swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
  });

  const swiperWidgetImages = new Swiper($widget.find(`.swiper-container-images`), {
    speed: 600,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    loop: widgetData.length > 1,
    watchOverflow: true,
    spaceBetween: 0,
    centeredSlides: false,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    a11y: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: $widget.find('.swiper-pagination'),
      clickable: true,
    },
  });

  const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
    speed: 600,
    spaceBetween: 0,
    centeredSlides: false,
    loop: widgetData.length > 1,
    watchOverflow: true,
    a11y: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: $widget.find(`.swiper-button-next`),
      prevEl: $widget.find(`.swiper-button-prev`),
    },
  });
  swiperWidgetImages.controller.control = swiperWidgetContent;
  swiperWidgetContent.controller.control = swiperWidgetImages;

  swiperImages = swiperWidgetImages;
  swiperContent = swiperWidgetContent;

  // --------------------------------------------
  // Observer to stop autoplay when user is not looking at the slider
  const sliderToObserve = $widget.find(`.swiper-container-images`).get(0);
  if (sliderToObserve) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            swiperWidgetImages.autoplay.start();
          } else {
            swiperWidgetImages.autoplay.stop();
          }
        }
      },
      { threshold: 0.3 },
    );

    observer.observe(sliderToObserve);
  }
}

// --------------------------------------------
// Swiper container structure
const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
      <div class="swiper-pagination desktop-pagination"></div>
    </div>

    <div class="content-wrap">
      <div class="mobile-controls">
        <div class="swiper-button-prev mobile-arrows"></div>
        <div class="swiper-pagination mobile-pagination"></div>
        <div class="swiper-button-next mobile-arrows"></div>
      </div>
      
      <div class="content-wrap-inner">
        <div class="swiper-button-prev desktop-arrows"></div>
        <div class="swiper-container swiper-container-content">
          <div class="swiper-wrapper"></div>
        </div>
        <div class="swiper-button-next desktop-arrows"></div>
      </div>
    </div>    
  `;

// --------------------------------------------
// Slide Template - Images
function buildSlideTemplateImages(slide) {
  const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;
  return template;
}

// --------------------------------------------
// Buttons
const buttons = function (btn1, btn2) {
  if (btn1 || btn2) {
    let btnContainer = $('<div class="button-container"></div>');
    if (btn1) {
      btnContainer.append(`<a href="${btn1}" class="button" ${openNewTab(btn1)}>More</a>`);
    }
    if (btn2) {
      btnContainer.append(`<a href="${btn2}" class="button" ${openNewTab(btn2)}>Buy now</a>`);
    }
    return btnContainer.prop('outerHTML');
  } else {
    return '';
  }
};

// --------------------------------------------
// Slide Template - Content
function buildSlideTemplateContent(slide) {
  const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class="wrap-content-slide">
          <h2 class="slide-title">${slide.Title}</h2>
          ${buttons(slide.URL, slide.PurchaseURL)}
          </div>
        </div>
      </div>
    `;

  return template;
}

// --------------------------------------------
// Update Swiper
function updateSwiper(swiperImages, swiperContent) {
  swiperImages.update();
  swiperContent.update();
  setTimeout(() => {
    swiperImages.update();
    swiperContent.update();
  }, 500);
}
